import React from 'react'

const AdItemPlaceholder = () => (
    <div className="ad-item-placeholder-container">
      <div className="ad-image-placeholder animated-background"></div>
      <div className="ad-title-placeholder animated-background"></div>
      <div className="ad-subtitle-placeholder animated-background"></div>
      <div className="ad-price-placeholder animated-background"></div>
    </div>
);

export default AdItemPlaceholder;





// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/WebGrid/adItemPlaceHolder.js